import serviceApi from 'services/api';
import auth from 'services/auth';

const api = process.env.REACT_APP_ENVIRONMENT === 'local' ? auth : serviceApi;

// The below interface is used for door objects
export interface DoorOptions {
  value: string;
  label: string;
}

/* The CardProps type represents the properties of a Card, including its UUID, description, buildingUuid, organizationUuid, badgeId, facilityCode, 
status, mobileUserUuid, and format. */
export type CardProps = {
  uuid?: string;
  description: string;
  buildingUuid: string;
  organizationUuid: string;
  badgeId?: number | string;
  facilityCode?: number | string;
  status?: string;
  mobileUserUuid?: string;
  format?: string;
  doorIds?: string[] | [];
  clickedButton?: string;
  startDate?: any;
  endDate?: any;
  assaCardType?: string;
  assaGuestCardType?: string;
};

/* The function `findAllCards` is an asynchronous function that makes a GET request to the `/apiv1/admin/cards` endpoint and returns 
all the Cards data from the response. */
const findAllCards = async (status?: string | null) => {
  const response = await api.get<CardProps[]>(`/apiv1/admin/cards?status=${status}`);
  return response?.data;
};

/* The function `findCardById` retrieves a Card object from an API based on the provided UUID. */
const findCardById = async (uuid: string | undefined) => {
  const response = await api.get<CardProps>(`/apiv1/admin/card/${uuid}`);
  return response?.data;
};

/* The function creates a new Card by making a POST request to the `/apiv1/admin/card` endpoint with the provided Card data. */
const createCard = async (newCard: CardProps) => {
  const response = await api.post<CardProps>('/apiv1/admin/card', newCard);
  return response?.data;
};

/* The function `updateCard` is an asynchronous function that updates a Card using a PUT request to an API endpoint. */
const updateCard = async (uuid: string | undefined, updatedCard: CardProps) => {
  const response = await api.put<CardProps>(`/apiv1/admin/card/${uuid}`, updatedCard);
  return response?.data;
};

/* The function `deleteCard` is an asynchronous function that deletes a Card by its UUID using an API call. */
const deleteCard = async (uuid: string | undefined) => {
  const response = await api.delete<CardProps>(`/apiv1/admin/card/${uuid}`);
  return response?.data;
};

const CardService = {
  findAllCards,
  findCardById,
  createCard,
  updateCard,
  deleteCard
};

export default CardService;
